import iconUserProfile from 'assets/images/ic-users-profiles-02.svg'
import iconOrgStructure from 'assets/images/ic-data-04.svg'
import iconMatrixApproval from 'assets/images/ic-check-square-broken.svg'
import iconWorkSettings from 'assets/images/ic-clock-forward.svg'
import iconManagementContract from 'assets/images/ic-file-attach-01.svg'
import iconManagementAccount from 'assets/images/ic-key-01.svg'
import iconAttendance from 'assets/images/ic-calendar-check-primary.svg'
import iconRequestShifting from 'assets/images/ic-arrow-switch-horizontal.svg'
import iconRequestLeave from 'assets/images/ic-luggage.svg'
import iconOvertime from 'assets/images/ic-clock-plus.svg'
import iconAdditionalIncentive from 'assets/images/ic-coin-hand.svg'
import iconRemoteWorking from 'assets/images/ic-home-05.svg'
import iconPayroll from 'assets/images/ic-payroll.svg'
import iconAppVersion from 'assets/images/ic-gear.svg'
import iconSop from 'assets/images/ic-file-check-02.svg'
import iconAnalytic from 'assets/images/ic-analytics.svg'
import iconHRMetrics from 'assets/images/ic-hr-metrics.svg'

export const PAGE_TITLE = 'AVO Innovation & Technology'

export const STEPS_IMPORT_EMPLOYEE_DATA = ['Upload File', 'Validation Employee Data', 'View Data', 'Import Data']

export const STEPS_IMPORT_EMPLOYEE_CONTRACT = [
    'Upload File',
    'Validation Employee Contract',
    'View Data',
    'Import Data',
]

export const STEPS_IMPORT_SHIFTING_SCHEDULE = [
    'Upload File',
    'Validation Import Shifting Schedule',
    'View Data',
    'Import Data',
]

export const STEPS_IMPORT_DATA_PAYROLL = ['Upload File', 'Validation Data', 'Import Data']

export const STEPS_CREATE_PAYROLL = [
    'pilih-bulan-payroll',
    'list-employee',
    'generate-komponen',
    'list-employee-payroll',
]

export const STEPS_IMPORT_GRADE = ['Upload File', 'Validation Data', 'Import Data']

export const MENU = [
    {
        name: 'Employee',
        slug: 'employee',
        icon: iconUserProfile,
        child: [
            {
                name: 'Active Employee',
                slug: 'active-employee',
            },
            {
                name: 'Former Employee',
                slug: 'former-employee',
            },
            {
                name: 'Prospective Employee',
                slug: 'prospective-employee',
            },
        ],
    },
    {
        name: 'Non-Employee Worker',
        slug: 'non-employee-worker',
        icon: iconUserProfile,
        child: [
            {
                name: 'Non-Employee List',
                slug: 'non-employee-list',
            },
            {
                name: 'Submitted Non-Employee List',
                slug: 'submitted-non-employee-list',
            },
            {
                name: 'Non-Employee Contract List',
                slug: 'non-employee-contract-list',
            },
        ],
    },
    {
        name: 'Management Structure Organization',
        slug: 'management-structure-organization',
        icon: iconOrgStructure,
        child: [
            {
                name: 'Grade Settings',
                slug: 'grade-settings',
            },
            {
                name: 'Job Title Settings',
                slug: 'job-title-settings',
            },
            {
                name: 'Work Unit Settings',
                slug: 'work-unit-settings',
            },
            {
                name: 'Structure Organization',
                slug: 'structure-organization',
            },
        ],
    },
    {
        name: 'Management Contract',
        slug: 'management-contract',
        icon: iconManagementContract,
        child: [
            {
                name: 'Employee List',
                slug: 'employee-list',
            },
            {
                name: 'Employee Contract List',
                slug: 'employee-contract-list',
            },
        ],
    },
    {
        name: 'Management Account',
        slug: 'management-account',
        icon: iconManagementAccount,
        child: [
            {
                name: 'Account Activation',
                slug: 'account-activation',
            },
            {
                name: 'Role Access',
                slug: 'role-access',
            },
        ],
    },
    {
        name: 'Work Settings',
        slug: 'work-settings',
        icon: iconWorkSettings,
        child: [
            {
                name: 'Work Time',
                slug: 'work-time',
            },
            {
                name: 'Day Off',
                slug: 'day-off',
            },
            {
                name: 'Event',
                slug: 'event',
            },
        ],
    },
    {
        name: 'Matrix Approval',
        slug: 'matrix-approval',
        icon: iconMatrixApproval,
        child: [
            {
                name: 'Approval Setting',
                slug: 'approval-setting',
            },
            {
                name: 'Activity Setting',
                slug: 'activity-setting',
            },
            {
                name: 'PNC Approver Setting',
                slug: 'pnc-approver-setting',
            },
        ],
    },
    {
        name: 'Attendance',
        slug: 'attendance',
        icon: iconAttendance,
        child: [
            {
                name: 'Attendance List',
                slug: 'attendance-list',
            },
            {
                name: 'Attendance Request List',
                slug: 'attendance-request-list',
            },
            {
                name: 'Attendance Analytics',
                slug: 'attendance-analytics',
            },
        ],
    },
    {
        name: 'Payroll',
        slug: 'payroll',
        icon: iconPayroll,
        child: [
            {
                name: 'Component Setting',
                slug: 'component-setting',
            },
            {
                name: 'List Payroll',
                slug: 'list-payroll',
            },
            {
                name: 'Create Payroll',
                slug: 'create-payroll',
            },
            {
                name: 'Incentive Setting',
                slug: 'incentive-setting',
            },
            {
                name: 'Tax Planning Setting',
                slug: 'tax-planning-setting',
            },
        ],
    },
    {
        name: 'Shifting',
        slug: 'shifting',
        icon: iconRequestShifting,
    },
    {
        name: 'Leave Management',
        slug: 'leave-management',
        icon: iconRequestLeave,
        child: [
            {
                name: 'Leave Request',
                slug: 'leave-request',
            },
            {
                name: 'Leave Analytics',
                slug: 'leave-analytics',
            },
        ],
    },
    {
        name: 'Overtime Request',
        slug: 'overtime-request',
        icon: iconOvertime,
    },
    {
        name: 'Remote Working Request',
        slug: 'remote-working-request',
        icon: iconRemoteWorking,
    },
    {
        name: 'Additional Incentive Request',
        slug: 'additional-incentive-request',
        icon: iconAdditionalIncentive,
    },
    {
        name: 'Employee Analytics',
        slug: 'employee-analytics',
        icon: iconAnalytic,
    },
    {
        name: 'Human Resource Metrics',
        slug: 'human-resource-metrics',
        icon: iconHRMetrics,
        child: [
            {
                name: 'Employee Happiness Index',
                slug: 'employee-happiness-index',
            },
            {
                name: 'Employee Productivity',
                slug: 'employee-productivity',
            },
            {
                name: 'Employee Internal Movement',
                slug: 'employee-internal-movement',
            },
            {
                name: 'Employee Development Summary',
                slug: 'employee-development-summary',
            },
        ],
    },
    {
        name: 'General Settings',
        slug: 'general-settings',
        icon: iconAttendance,
        child: [
            {
                name: 'Leave Setting',
                slug: 'leave-setting',
            },
            {
                name: 'Remote Working Setting',
                slug: 'remote-working-setting',
            },
            {
                name: 'Overtime Setting',
                slug: 'overtime-setting',
            },
            {
                name: 'Announcement',
                slug: 'announcement',
            },
        ],
    },
    {
        name: 'SOP Settings',
        slug: 'sop-settings',
        icon: iconSop,
        child: [
            {
                name: 'SOP Category',
                slug: 'sop-category',
            },
            {
                name: 'SOP List',
                slug: 'sop-list',
            },
        ],
    },
    {
        name: 'Application Version',
        slug: 'application-version',
        icon: iconAppVersion,
    },
]

export const CREATE_COMPANY_FORM = [
    {
        label: 'Logo Perusahaan',
        key: 'logo',
        type: 'upload',
    },
    {
        label: 'Nama PT',
        key: 'name',
        placeholder: 'Isi nama PT',
    },
    {
        label: 'Kode PT',
        key: 'code',
        placeholder: 'Isi kode PT',
    },
    {
        label: 'Tgl Berdiri PT',
        type: 'date',
        key: 'establishment_date',
        placeholder: 'Pilih tanggal berdiri',
    },
    {
        label: 'No. Surat Keterangan Usaha',
        key: 'business_certificate_number',
        placeholder: 'Isi nomor surat keterangan usaha',
    },
    {
        label: 'No. Akta Perusahaan',
        key: 'company_deed_number',
        placeholder: 'Isi nomor akta perusahaan',
    },
    {
        label: 'Akun Payroll',
        key: 'payment_account',
        type: 'option',
    },
]

export const ACTION_TYPE = {
    CREATE: 'CREATE',
    EDIT: 'EDIT',
    DELETE: 'DELETE',
    UPDATE_STATUS: 'UPDATE_STATUS',
    UPDATE_ROLE: 'UPDATE_ROLE',
    PREVIEW: 'PREVIEW',
    DETAIL: 'DETAIL',
    PAYROLL_NOTES: 'PAYROLL_NOTES',
    ARCHIVE: 'ARCHIVE',
}

export const STATUS_TYPE = {
    DRAFT: 'draft',
    ACTIVE: 'active',
    PENDING: 'pending',
    ADDENDUM: 'addendum',
    INTERIM: 'interim',
    RENEW: 'renew',
}

export const STATUS_EMPLOYEE = {
    DRAFT: 'draft',
    SUBMITTED: 'submitted',
    REGISTERED: 'registered',
    ACTIVE: 'active',
    SUSPEND: 'suspend',
    INACTIVE: 'inactive',
    BLACKLIST: 'blacklist',
    CONTRACT_REJECTED: 'contract-rejected',
}

export const MODULE_INITIAL = {
    HR: 'hr',
    ACCESS_MANAGEMENT: 'ea',
    SALES_ORDER: 'so',
    PROCUREMENT: 'pr',
    FINANCE: 'fn',
}
